module.exports = __webpack_public_path__ + "static/img/lock-fr.8a9363f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/music/img/lock-fr.png
// module id = MMhw
// module chunks = 1